module.exports = "/_next/static/images/pf-4c112e5a233a85054f056cfa369d41ef.svg";